import i18next from 'i18next';
import i18nextICU from 'i18next-icu';
import { Translations } from '../types/Translations';
import { defaultUserLang } from './defaultUserLang';

export const initI18n = (resources: Translations, lng: string = defaultUserLang): void => {
  i18next.use(i18nextICU).init({
    lng,
    fallbackLng: defaultUserLang,
    keySeparator: '$',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      [lng]: {
        translation: resources,
      },
    },
  });
};

export const addI18nResources = (resources: Translations, lng: string = defaultUserLang): void => {
  i18next.addResourceBundle(lng, '', resources);
};

export const t = (keys: string | string[], options?: any): string => i18next.t(keys, options) as string;
